import { z } from "zod";

const envSchema = z.object({
  VITE_PUBLIC_API_URL: z.string().url().optional()
});

const parsed = envSchema.safeParse(import.meta.env);
if (!parsed.success) throw new Error("Variables de entorno invalidas para DL Games.");

const DEFAULT_API_URL = import.meta.env.DEV ? "http://localhost:8787" : "https://dl-games-api.pikaboygamerr.workers.dev";

export const API_URL = parsed.data.VITE_PUBLIC_API_URL ?? DEFAULT_API_URL;
